<script>
    import {cloneDeep} from 'lodash'
    export default {
      name: "filter-dialog",
      props:{
        dialogOption:{
          type:Object ,
          default:()=>({
            header:"Фильтр",
            applyBtnName:"Применть",
            cancelBtnName:"Отменить"
          })
        },
        initFilters:{
          type: Array,
          default:[]
        },
        filterProperties:{
          type: Object,
          default:()=>{return {}}
        },
        height:{
          type:Number,
          default:400
        },
        operationMatchOptions:{
          type:Array,
          default:()=>{
            return [
              {
                "match":[{"type":"integer"},{"type":"number"}],
                "options":[
                  {title:"Больше чем",value:">"},
                  {title:"Меньше чем",value:"<"},
                  {title:"Больше, либо равно",value:">="},
                  {title:"Меньше, либо равно",value:"<="},
                  {title:"Равно",value:"="}
                ]
              },
              {
                "match":[{"type":"string"}],
                "options":[
                  {title:"Включает",value:":"},
                  {title:"Точное совпадение",value:"="},
                ]
              }
            ]
          }
        },

      },
      data(){
        return {
          filters:cloneDeep(this.initFilters),
        }
      },
      methods:{
        generateSearchStr(filters){
          return filters.filter(f=>f.propDescriptor&&f.operationDescriptor&&f.value).map(f=>f.propDescriptor.propName+f.operationDescriptor.value+f.value).join(",")
        }
      },
      render(createElement) {
        const optionsForProp = this.$jsonSchemeUtils.propertiesToArrayRecursive(this.filterProperties)
          //.filter(item=>!this.filters.some(filter=>filter.propDescriptor&&(filter.propDescriptor.propName==item.propName)))//Исключаем props которые уже добавлены

        const columns = [
          {
            path:'propDescriptor',
            layout:{
              "component":"select-element",
              "params":{
                "class":"fluid",
                "props":{
                  "options":optionsForProp,
                  "initValue":"{vue.data.rowData.propDescriptor||null}"
                },
                "on":{
                  "input":"{function(e){Vue.$nestedSet(vue.data.rowData,'propDescriptor', e)}}",
                }

              }
            }
          },
          {
            path:'operationDescriptor',
            layout2:{
              "component":"select-element",
              "vIf":"{vue.externalData.rowData.propDescriptor}",
              "data":{
                "matchOptions":this.operationMatchOptions
              },
              "params":{
                "class":"fluid",
                "props":{
                  "options":"{(vue.$userUtils.matcher(vue.externalData.rowData.propDescriptor?vue.externalData.rowData.propDescriptor.prop:null,vue.data.matchOptions)||{}).options}",
                  "initValue":"{vue.externalData.rowData.operationDescriptor}"
                },
                "on":{
                  "input":"{function(e){Vue.$nestedSet(vue.externalData.rowData,'operationDescriptor', e)}}",
                }
              }
            }
          },
          {
            path:'value',
            layout2:{
              "component":"div",
              "vIf":"{vue.externalData.rowData.propDescriptor}",
              "params":{
                "class":"ui input",
                "style":"width:100%"
              },
              "children":[
                {
                  "component":"input-control",
                  "params":{
                    "props":{
                      "property": "{vue.externalData.rowData.propDescriptor.prop}",
                      "value":"{vue.externalData.rowData.value}"
                    },
                    "on":{
                      "input":"{function(e){Vue.set(vue.externalData.rowData,'value',e)}}"
                    }
                  }
                }
              ]

            }
          },
        ];
        return createElement('elastic-dialog',
          {
            "props":{
              "header":this.dialogOption.header,
              "applyBtnName":this.dialogOption.applyBtnName,
              "cancelBtnName":this.dialogOption.cancelBtnName
            },
            "on":{
              "apply":(e)=>{this.$emit('apply',this.filters);this.$emit('searchStr',this.generateSearchStr(this.filters))},
              "cancel":(e)=>this.$emit('cancel',this.filters)
            }
          },[
            createElement('div',{
              "style":{
                "width":"100%",
                "height":this.height+"px"
              }
            },[
              createElement('control-table',{
                "props":{
                  "showHeader":false,
                  "enableBottomRow":true,
                  "enableLastColumn":true,
                  "placeholder":'',
                  "rows":this.filters,
                  "columns":columns,
                },
                "on":{
                  "clickedAddRowButton":(e)=>this.filters.push({}),
                  "clickedDelRowButton":(rowIndex)=>this.filters.splice(rowIndex, 1),
                }
              },[])
            ]),

          ]);
      }

    }
</script>

<style scoped>

</style>
